import axios from '../axios/axios-auth'

export default class WorkAnalyzerService {

    getOperationTypes(orgId) {
        return axios.get(`/agro-service/v1/work-analyzer/${orgId}/operation-types`)
    }

    getData(orgId, body, endpoint) {
        return axios.post(`/agro-service/v1/work-analyzer/${orgId}/${endpoint}`, body)
    }

    getFilterList(orgId, operationType, filter) {
        return axios.get(`/agro-service/v1/work-analyzer/${orgId}/filter/${operationType}/${filter}`)
    }
}
